import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { generateId } from '../../utils';
import { eventEmitter as em } from '../event-emitter';
import { isJSModuleWithDefaultExport } from './utils';
export function JSResource(loader, opts) {
  var moduleId = opts.moduleId,
    moduleName = opts.moduleName,
    modulePath = opts.modulePath,
    priority = opts.priority;
  var listeners = new Set();
  var promise;
  var state = {
    type: 'init'
  };
  function createOnLoad(event) {
    return function (module) {
      em.emit('jsresource.load.complete', event);
      state = {
        type: 'module',
        module: module
      };
      var _iterator = _createForOfIteratorHelper(listeners),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var listener = _step.value;
          listener.onLoad(module);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
  }
  function createOnError(event) {
    return function (error) {
      em.emit('jsresource.load.error', _objectSpread(_objectSpread({}, event), {}, {
        error: error
      }));
      state = {
        type: 'error',
        error: error
      };
      var _iterator2 = _createForOfIteratorHelper(listeners),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _listener$onError;
          var listener = _step2.value;
          (_listener$onError = listener.onError) === null || _listener$onError === void 0 || _listener$onError.call(listener, error);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
  }
  return {
    getModuleId: function getModuleId() {
      return moduleId;
    },
    getModuleName: function getModuleName() {
      return moduleName;
    },
    getModulePath: function getModulePath() {
      return modulePath;
    },
    getPriority: function getPriority() {
      return priority;
    },
    getModuleIfRequired: function getModuleIfRequired() {
      if (state.type === 'error') {
        throw state.error;
      }
      return state.type === 'module' ? state.module : null;
    },
    load: function load() {
      if (!promise) {
        var event = {
          moduleId: moduleId,
          transactionId: generateId()
        };
        var onError = createOnError(event);
        var onLoad = createOnLoad(event);
        em.emit('jsresource.load.start', event);
        try {
          promise = loader().then(function (result) {
            var module = isJSModuleWithDefaultExport(result) ? result.default : result;
            onLoad(module);
            return module;
          }).catch(function (error) {
            onError(error);
            throw error;
          });
        } catch (error) {
          if (error instanceof Error) {
            onError(error);
          }
          promise = Promise.reject(error);
        }
      }
      return promise;
    },
    onComplete: function onComplete(onLoad, onError) {
      if (state.type === 'module') {
        onLoad(state.module);
        return function () {};
      }
      if (state.type === 'error') {
        onError === null || onError === void 0 || onError(state.error);
        return function () {};
      }
      var listener = {
        onError: onError,
        onLoad: onLoad
      };
      listeners.add(listener);
      return function () {
        listeners.delete(listener);
      };
    }
  };
}